import { render, staticRenderFns } from "./QuestionEditDocuments.vue?vue&type=template&id=74fb0b9d"
import script from "./QuestionEditDocuments.vue?vue&type=script&lang=js"
export * from "./QuestionEditDocuments.vue?vue&type=script&lang=js"
import style0 from "./QuestionEditDocuments.vue?vue&type=style&index=0&id=74fb0b9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports